<template>
    <div :class="{'nav-open': $sidebar.showSidebar}">
        <notifications transition-name="notification-list" transition-mode="out-in">

        </notifications>
        <router-view name="header"></router-view>
        <transition name="fade"
                    mode="out-in">
            <router-view></router-view>
        </transition>
        <router-view name="footer"></router-view>

        <modal class="gdpr-prompt" v-model="GDPRPrompt" :title="$t('GDPR Title')" :submit="accept" :cancel="$auth.logout" submit-text="GDPR Accept" cancel-text="GDPR Decline">
            <template slot="body">
                <p class="pre-formatted">{{$t('GDPR Info')}}</p>
            </template>
        </modal>

    </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-notifyjs/themes/default.css'
  import Modal from './components/Dashboard/Components/BasicModal'
  import throttle from 'lodash/throttle'
  import axios from 'axios'
  import moment from "moment"

  export default {
    components: {
      Modal
    },
    data () {
      return {
        version: null,
        GDPRPrompt: false,
        throttledFetchVersion: throttle(this.fetchVersion.bind(this), 30 * 1000)
      }
    },
    mounted () {
      this.fetchVersion()
      if (window.innerWidth > 1470) {
        if (document.body.classList.contains('sidebar-mini')) {
          document.body.classList.remove('sidebar-mini')
          this.$sidebar.isMinimized = false 
        }
      } else {
        if (!document.body.classList.contains('sidebar-mini')) {
          document.body.classList.add('sidebar-mini')
          this.$sidebar.isMinimized = true
        }
      }
      window.sidebar = this.$sidebar
      window.addEventListener('resize', function() {
        if (this.window.innerWidth > 1470) {
          if (document.body.classList.contains('sidebar-mini')) {
            document.body.classList.remove('sidebar-mini')
            this.window.sidebar.isMinimized = false
          }
        } else {
          if (!document.body.classList.contains('sidebar-mini')) {
            document.body.classList.add('sidebar-mini')
            this.window.sidebar.isMinimized = true
          }
        }
      })
    },
    methods: {
      async fetchVersion () {
        try {
          const response = await axios.get('/api/version')
          this.version = response.data
        } catch (e) {
          this.$notify({ message: e.message, type: 'danger' })
        } finally {

        }
      },
      async accept () {
        await this.$auth.updateUser({email: this.$auth.user.email, GDPRConfirmed: true})
      },
      setLang: function (lang) {
        this.$i18n.locale = lang
        moment.locale(lang)
        localStorage.setItem('locale', lang)
      }
    },
    watch: {
      '$route' () {
        this.throttledFetchVersion()
      },
      'version' (val) {
        if (val) {
          const version = JSON.parse(localStorage.getItem('version'))

          if (version && version.version.localeCompare(val.version) !== 0) {
            localStorage.setItem('version', JSON.stringify(val))
            window.location.reload()
          } else {
            localStorage.setItem('version', JSON.stringify(val))
          }
        }
      },
      '$auth.user.GDPRConfirmed' (val) {
        this.GDPRPrompt = !val
      },
      '$auth.user.customer.settings.contract.enabledLanguages' () {
        if (
            !this.$auth.user.customer.settings.contract.enabledLanguages.includes(
                localStorage.getItem('locale')
            )
        ) {
          this.setLang(this.$auth.user.customer.settings.language)
        } else {
          this.setLang(localStorage.getItem('locale'))
        }
      }
    }
  }
</script>
<style lang="scss">
    .gdpr-prompt .modal-dialog {
        max-width: 600px !important;
    }

    .pre-formatted {
      white-space: pre-wrap;
    }
</style>
